import React from "react"

import HeaderSectionDesktop from "./HeaderSectionDesktop"
import HeaderSectionMobile from "./HeaderSectionMobile"

const HeaderSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <HeaderSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    return (
      <HeaderSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <HeaderSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  return (
    <HeaderSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  )
}

export default HeaderSection
